/**
 * Settings Component Constants
 * Centralized constants for pagination, page sizes, and other common values
 */

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
export const DEFAULT_CURRENT_PAGE = 1;

// Search
export const MIN_SEARCH_LENGTH = 1;
export const SEARCH_DEBOUNCE_MS = 300;

// User Types
export const USER_TYPES = {
  OWNER: 'OWNER',
  INTERNAL_ADMIN: 'INTERNALADMIN',
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

// Status
export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
} as const;

// Modal Types
export const MODAL_TYPES = {
  ADD_USER: 'ADD_USER',
  EDIT_USER: 'EDIT_USER',
  DELETE_USER: 'DELETE_USER',
  CONFIRM: 'CONFIRM',
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  FOUND: 302,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
} as const;

// Toast Messages
export const TOAST_MESSAGES = {
  USER_DELETED_SUCCESS: 'User deleted successfully',
  USER_UPDATED_SUCCESS: 'User updated successfully',
  USER_CREATED_SUCCESS: 'User created successfully',
  ERROR_LOADING_USERS: 'Failed to load users',
  ERROR_DELETING_USER: 'Failed to delete user',
  ERROR_UPDATING_USER: 'Failed to update user',
  ERROR_CREATING_USER: 'Failed to create user',
  ERROR_SWITCHING_USER: 'Failed to switch user',
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  SUPER_ADMIN_ID: 'super-admin',
  SUPER_ADMIN_TOKEN: 'super-admin-token',
  SUPER_ADMIN_NAME: 'super-admin-name',
  SUPER_ADMIN_USERTYPE: 'super-admin-usertype',
} as const;

export type UserType = typeof USER_TYPES[keyof typeof USER_TYPES];
export type UserStatus = typeof USER_STATUS[keyof typeof USER_STATUS];
export type ModalType = typeof MODAL_TYPES[keyof typeof MODAL_TYPES];
export type PageSizeOption = typeof PAGE_SIZE_OPTIONS[number];
